import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import BigCalendar from 'react-big-calendar';
import AgendaLotEventDetailModal from '~/containers/agendaLotEventDetailModal/agendaLotEventDetailModal';
import AgendaList from '~/components/agendaList/agendaList';
import AgendaListTitle from '~/components/agendaListTitle/agendaListTitle';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import styles from './styles.css';

export const getAgendaQuery = gql`
  query agenda($breweryId: Int!, $startDate: String!, $endDate: String!) {
    agenda(breweryId: $breweryId, startDate: $startDate, endDate: $endDate) {
      lotId
      lot {
        id
        reference
        status
        volume
        product {
          id
          name
        }
        startDate
      }
      lotTransfer {
        id
        type
        name
        tankType
        vesselDescription
        requiresDutyPaid
        transferDate
        tankId
        status
        lot {
          id
          reference
          currentVolume
          dutyPaid
          volume
          product {
            id
            name
            costPerLitre
            variants {
              id
              vesselType {
                id
                quantity
                volume
              }
            }
          }
        }
        location {
          id
          name
        }
      }
      date
      type
    }
  }
`;

moment.locale('ko', {
  week: {
    dow: 1,
    doy: 1
  }
});
const localizer = BigCalendar.momentLocalizer(moment);

const mushEvents = events =>
  events.map(event => {
    const day = moment(event.date);
    return {
      start: day,
      end: day,
      allDay: true,
      resource: event
    };
  });

const formats = {
  agendaDateFormat: 'dddd Do MMMM'
};

const getStartAndEndDates = (date, viewType) => {
  const startEndType = viewType === 'month' ? 'month' : 'isoWeek';
  const format = 'YYYY-MM-DD';

  return {
    startDate: moment(date)
      .startOf(startEndType)
      .format(format),
    endDate: moment(date)
      .endOf(startEndType)
      .format(format)
  };
};

export class Agenda extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEvent: null,
      startDate: moment()
        .startOf('isoWeek')
        .format('YYYY-MM-DD'),
      endDate: moment()
        .endOf('isoWeek')
        .format('YYYY-MM-DD'),
      viewType: 'agenda'
    };
  }

  onModalToggle = () => {
    this.setState({
      selectedEvent: null
    });
  };

  onSelectEvent = selectedEvent => {
    this.setState({
      selectedEvent
    });
  };

  classNameForEvent = event => {
    if (event.resource.type === 'LOT_TRANSFER') {
      switch (event.resource.lotTransfer.type) {
        case 'TANK':
          return { className: styles.tank };
        case 'VESSEL':
          return { className: styles.vessel };
        case 'LOCATION':
          return { className: styles.location };
        case 'DRY_HOP':
          return { className: styles.dryHop };
        case 'CLARIFICATION':
          return { className: styles.clarification };
        default:
          return null;
      }
    }
    if (event.resource.type === 'SCHEDULED_LOT') {
      return { className: styles.scheduledLot };
    }

    return null;
  };

  onNavigate = (date, viewType, action) => {
    const type = viewType === 'month' ? 'month' : 'week';
    const { startDate } = this.state;
    let dateToUse;
    switch (action) {
      case 'PREV':
        dateToUse = moment(startDate).subtract(1, type);
        break;
      case 'NEXT':
        dateToUse = moment(startDate).add(1, type);
        break;
      default:
        dateToUse = date;
    }

    this.setState(getStartAndEndDates(dateToUse, viewType));
  };

  onView = viewType => {
    const dates = getStartAndEndDates(this.state.startDate, viewType);
    this.setState({ viewType, ...dates });
  };

  render() {
    const { brewery } = this.props;
    const { selectedEvent, startDate, endDate, viewType } = this.state;

    return (
      <Query
        query={getAgendaQuery}
        variables={{
          breweryId: brewery.id,
          startDate,
          endDate
        }}
        fetchPolicy={'cache-and-network'}
      >
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const events = mushEvents(data.agenda);
          return (
            <div className={`content ${styles.container}`}>
              <BigCalendar
                views={{
                  month: true,
                  agenda: AgendaList
                }}
                defaultView={viewType}
                onNavigate={this.onNavigate}
                onView={this.onView}
                formats={formats}
                popup
                date={moment(startDate).toDate()}
                events={events}
                localizer={localizer}
                startAccessor="start"
                endAccessor="end"
                titleAccessor={AgendaListTitle}
                onSelectEvent={this.onSelectEvent}
                eventPropGetter={this.classNameForEvent}
              />
              <AgendaLotEventDetailModal
                isOpen={!!selectedEvent}
                lotId={selectedEvent ? selectedEvent.resource.lotId : null}
                consolidatedLotId={selectedEvent ? selectedEvent.resource.consolidatedLotId : null}
                event={selectedEvent ? selectedEvent : null}
                onToggle={this.onModalToggle}
              />
            </div>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(Agenda);



// WEBPACK FOOTER //
// ./src/containers/agenda/agenda.jsx